export default __webpack_public_path__ + "static/assets/NunitoExtraBold.f9dbacf8.woff";